import { Paper } from "@mui/material";
import { PropsWithChildren } from 'react';

export type StepMenuActionsProps = {};

export default function StepMenuActions({
    children
}: PropsWithChildren<StepMenuActionsProps>) {
    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "row",
                flexGrow: 0,
                flexShrink: 0,
                padding: 1,
                borderTop: "1px solid",
                borderTopColor: "divider",
                position: "relative",
                zIndex: theme => theme.zIndex.appBar
            }}
        >
            {children}
        </Paper>
    );
}